import React, { memo, useMemo } from 'react';
import { Box, Drawer } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import CloseButton from 'components/@home/drawers/CloseButton';
import devicesDrawer from 'store/app/ui/drawers/devices/action';
import authCompany from 'store/selectors/authCompany';
import authEmployee from 'store/selectors/authEmployee';
import DevicesForm from './DevicesForm';

const DevicesDrawer = () => {
  const dispatch = useDispatch();

  const drawerState = useSelector(state => state.drawers?.devices || {});

  const company = useSelector(authCompany);
  const currentEmployee = useSelector(authEmployee);
  const employee = useMemo(
    () => (drawerState.employeeId ? { _id: drawerState.employeeId } : currentEmployee),
    [drawerState.employeeId, currentEmployee],
  );

  const handleClose = () => {
    dispatch(devicesDrawer.close());
  };

  return (
    <Drawer
      anchor="right"
      open={!!drawerState.isOpen}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            width: 600,
            maxWidth: '90%',
            display: 'flex',
            flexDirection: 'row',
            overflow: 'visible',
            alignItems: 'flex-start',
            paddingTop: '20px',
            paddingLeft: '20px',
            height: '100vh',
          },
        },
      }}
    >
      <CloseButton onClick={handleClose} />
      <Box
        sx={{
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          marginTop: '-20px',
          height: '100%',
        }}
      >
        {employee?._id && company?._id && <DevicesForm company={company} employee={employee} />}
      </Box>
    </Drawer>
  );
};

export default memo(DevicesDrawer);
